import styled, { css } from 'styled-components';
import { breakpointMap, theme } from '../../../theme';
import { Heading, StyledHeadingProps } from '../../typography';
import { StyledItemCardProps } from './ItemCard';

export const ItemCardTitle = styled(Heading)<
  Pick<StyledHeadingProps, 'size'> & {
    cardSize: StyledItemCardProps['size'];
  }
>`
  ${({ cardSize, size: headingSize }) =>
    breakpointMap(cardSize, (size) =>
      size === 'xs'
        ? css`
            ${theme.typography.uiText.md};
            font-weight: bold;
          `
        : css`
            ${theme.typography.headings[headingSize]['xl']}
          `
    )};
`;
